import { DataBean } from "../DataBean";

export class GetProjectInfo extends DataBean {



    public async getProjectDataCatalog(tableName: any, idProject: any, regexStr: any, idAccount: any, state: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProjectDataCatalog_String_Number_String_Number_Number_Number_Number", [tableName, idProject, regexStr, idAccount, state, page, recordsPerPage]);
    }

}